import { usePlayerTemplateMap } from './usePlayer';

import { FieldPlayer } from '@/components';
import { Maybe } from '@/types';
import { EnumTeamContext, PlayerF5 } from '@/types/team';
import { PlayerMyTeamF5 } from '@/types/teamf5';
import { getShortNamePlayerPosition, POSITIONS_LABELS } from '@/utils';

type GetPlayersOnFieldOptions = {
  team: PlayerF5[] | PlayerMyTeamF5[];
  context?: EnumTeamContext;
  handleSelectPlayer: (
    player: PlayerF5 | PlayerMyTeamF5,
    toBeChanged?: boolean
  ) => void;
};

export const useTeam = () => {
  const playerTemplateMap = usePlayerTemplateMap();
  const getPlayersOnField = (options: GetPlayersOnFieldOptions) => {
    const { handleSelectPlayer, team, context } = options;

    const players: {
      goalkeeper: Maybe<JSX.Element>;
      fieldPlayers: JSX.Element[];
    } = {
      fieldPlayers: [],
      goalkeeper: null,
    };

    const isScoreField =
      context === EnumTeamContext.Score11 || context === EnumTeamContext.Score5;
    const isChange = context === EnumTeamContext.Changes11;

    for (let i = 1; i <= team.slice(-4).length; i++) {
      const playerInfo = playerTemplateMap.get(team[i].id);
      players.fieldPlayers.push(
        <FieldPlayer
          context={context}
          data={team[i]}
          id={String(i)}
          positionLabel="Agregar"
          onClick={() =>
            !isScoreField &&
            handleSelectPlayer(
              playerInfo
                ? {
                    ...team[i],
                    orden: i,
                    posicion: {
                      nombreCorto: getShortNamePlayerPosition(playerInfo?.p),
                      id: playerInfo.p,
                    },
                  }
                : {
                    ...team[i],
                    orden: i,
                    posicion: {
                      nombreCorto: POSITIONS_LABELS.all_field_players,
                      id: i,
                    },
                  },
              isChange
            )
          }
        />
      );
    }
    players.goalkeeper = (
      <FieldPlayer
        context={context}
        data={team[0]}
        id="0"
        positionLabel="ARQ"
        onClick={() => {
          !isScoreField &&
            handleSelectPlayer(
              {
                ...team[0],
                orden: 0,
                posicion: {
                  nombreCorto: POSITIONS_LABELS.abbreviation.ARQ,
                  id: 0,
                },
              },
              isChange
            );
        }}
      />
    );

    return players;
  };

  return { getPlayersOnField };
};
